import { Injectable } from '@angular/core';
import { first } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { PickingService } from './picking.service';
import { PackingOutOrderDetailsComponent } from '../../modals/packing-out-order-details/packing-out-order-details.component';
import { PickingOrderType } from '../../pages/picking/picking-order-type.enum';
import { ActionService } from './action.service';
import { ErrorsEnum, ErrorService } from './error.service';

interface DialogResponse {
  removeOrder?: boolean;
  resetOrder?: boolean;
  orderId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PackingModalService {

  private openOutOrderDetailsLock = false;

  constructor(private dialog: MatDialog,
              private actionService: ActionService,
              private errorService: ErrorService,
              private pickingService: PickingService) {
  }

  async openOutOrderDetails(outOrderNumber: string, orderType?: PickingOrderType) {
    if(!this.openOutOrderDetailsLock){
      this.openOutOrderDetailsLock = true;
      const outOrder = await this.pickingService.getDetails(outOrderNumber);
      const dialogRef = this.dialog.open(PackingOutOrderDetailsComponent, {
        data: { outOrder, orderType },
        panelClass: 'details-modal',
        autoFocus: false
      });
      dialogRef.afterOpened().pipe(first()).subscribe(() => {
        this.openOutOrderDetailsLock = false;
      }, error => {
        console.log(error)
      });

      dialogRef.afterClosed().pipe(first()).subscribe(async (res: DialogResponse) => {
        if (res?.removeOrder) {
          await this.removeOrder(res.orderId);
        }

        if (res?.resetOrder) {
          await this.resetOrder(res.orderId);
        }
      }, error => {
        console.log(error)
      });
      return dialogRef;
    } else{
      return null;
    }
  }

  async removeOrder(orderId: string) {
    try {
      await this.actionService.removeOutOrder({ id: orderId });
    } catch (err) {
      this.errorService.openErrorSnackBar(err);
    }
  }

  async resetOrder(orderId: string) {
    try {
      await this.actionService.resetOutOrder({ outOrderId: orderId });
    } catch (err) {
      this.errorService.openErrorSnackBar(err);
      switch (err.error.type) {
        case ErrorsEnum.PACKING_ERROR_TASK_CONFLICT:
          const message = 'A ordem de saída possui tarefas em andamento. Por favor, remova as tarefas antes de prosseguir.';
          this.errorService.openErrorSnackBarWithCustomMessage(message);
          break;
      }
    }
  }

}
